import request from "@/utils/request.js";


// 查询启用的数据
export function listEnableHxCarouse() {
    return request({
        url: "/website/carousel/listEnableHxCarouse",
        method: "get",
    });
}
